module.exports = __webpack_public_path__ + "img/icon11.4c85d45c.png";